/* EDUMON v7.1.4 — Force line-break after "!" in drawer titles (Cart + Product)
   - Inserts <br class="edm-br"> right after the first (or any) exclamation mark in titles
   - Works for dynamically injected content via MutationObserver
   - Safe inside anchors (phrasing content)

   How to use:
   1) Upload this file as assets/edumon-bang-breaks.js
   2) Include it in theme.liquid before </body>:
      <script src="{{ 'edumon-bang-breaks.js' | asset_url }}" defer></script>
*/
(function(){
  const SELECTORS = [
    '#edm-product-drawer .edm-drawer__title',
    '.cart-drawer .cart-item__name',
    '.edm-cart .cart-item__name'
  ];
  const TARGETS = SELECTORS.join(',');

  /** Returns true if there is any non-whitespace text AFTER the offset within the element */
  function elementHasFollowingText(el, node, offset){
    try{
      const r = document.createRange();
      r.setStart(node, Math.min(offset, node.length));
      r.setEnd(el, el.childNodes.length);
      return /\S/.test(r.toString());
    }catch(_){ return false; }
  }

  /** Walk text nodes and insert <br.edm-br> right after '!' (only if text continues afterwards) */
  function insertBreaksAfterBang(el){
    if(!el || !(el instanceof Element)) return;
    // If we've already inserted at least one custom break, assume processed
    if(el.querySelector('br.edm-br')) return;

    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    const nodesToReplace = [];

    while(walker.nextNode()){
      const t = walker.currentNode;
      if(!t.nodeValue || t.nodeValue.indexOf('!') === -1) continue;
      nodesToReplace.push(t);
    }

    for(const textNode of nodesToReplace){
      const text = textNode.nodeValue;
      const frag = document.createDocumentFragment();
      let i = 0;
      let changed = false;
      while(i < text.length){
        const idx = text.indexOf('!', i);
        if(idx === -1){
          frag.appendChild(document.createTextNode(text.slice(i)));
          break;
        }
        // text before '!'
        if(idx > i) frag.appendChild(document.createTextNode(text.slice(i, idx)));
        // the '!'
        frag.appendChild(document.createTextNode('!'));
        // only insert a break if there is actual content following in the overall element
        const hasNext = (idx + 1 < text.length) || elementHasFollowingText(el, textNode, idx + 1);
        if(hasNext){
          const br = document.createElement('br');
          br.className = 'edm-br';
          frag.appendChild(br);
          changed = true;
        }
        i = idx + 1;
      }
      if(changed){
        textNode.parentNode.replaceChild(frag, textNode);
      }
    }
  }

  function processAll(root){
    root.querySelectorAll(TARGETS).forEach(insertBreaksAfterBang);
  }

  // Initial run
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', () => processAll(document));
  }else{
    processAll(document);
  }

  // Observe dynamic changes (drawers open/update)
  const mo = new MutationObserver(mutations => {
    for(const m of mutations){
      if(m.type === 'childList'){
        m.addedNodes.forEach(n => {
          if(!(n instanceof Element)) return;
          if(n.matches && n.matches(TARGETS)) insertBreaksAfterBang(n);
          else processAll(n);
        });
      }
      if(m.type === 'characterData'){
        const host = m.target.parentElement && m.target.parentElement.closest(TARGETS);
        if(host) insertBreaksAfterBang(host);
      }
    }
  });
  mo.observe(document.body, {subtree:true, childList:true, characterData:true});
})();

/* Optional (already in your CSS, repeat here for clarity):
#edm-product-drawer .edm-drawer__title :is(br.edm-br, wbr){ display:block; }
:where(.cart-drawer,.edm-cart) .cart-item__name br.edm-br{ display:block; }
*/
